import { QueryEntity } from '@datorama/akita';
import { CapabilitiesState } from 'core-app/core/state/capabilities/capabilities.store';

export class CapabilitiesQuery extends QueryEntity<CapabilitiesState> {
}
